<template>
  <v-card>
      <v-card-text class="pa-0">
          <v-layout class="ma-0">
              <v-flex xs3 class="align-self-center pa-1"> 
                  <v-list>
                      <v-list-tile avatar>
                          <v-list-tile-avatar>
                              <v-img
                                  :src="mediaLogo"
                                  :width="40"
                                  :height="40"
                              />
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                              <v-list-tile-title>
                                  {{ mediaName }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                  {{ journalType }}
                                  &bull;
                                  {{ publishDate | customDate }}
                              </v-list-tile-sub-title>
                          </v-list-tile-content>
                      </v-list-tile>
                  </v-list>
              </v-flex>
              <v-divider v-if="keywords && keywords.length > 0" vertical class="my-3" />
              <v-flex 
                  v-if="keywords && keywords.length > 0" 
                  class="align-self-center pa-1"
              >
                  <v-container class="pa-2">
                      <span class="body-2 grey--text">Keywords: </span>
                      <v-chip
                          v-for="keyword in keywords"
                          :key="keyword"
                          label
                          color="primary"
                          text-color="white"
                      >
                          <span class="zawgyi">{{ keyword | textLowerCase | zgtext }}</span>
                      </v-chip>
                  </v-container>
              </v-flex>
          </v-layout>
      </v-card-text>
  </v-card>
</template>

<script>
import keywords from "@/mixins/keywords";
import custom_date from "@/mixins/custom_date";

export default {
  mixins: [ keywords, custom_date ],

  props: [
    "mediaLogo",
    "mediaName",
    "journalType",
    "publishDate",
    "keywords",
  ],
}
</script>